import * as React from 'react';
import $ from "jquery";
import { Box, Button, Card, CardContent, CircularProgress, Stack, Typography } from '@mui/material';
import Common from '../../utilities/common';
import { PieChart } from '@mui/x-charts/PieChart';
import ReactInterval from 'react-interval';
import { LineChart } from '@mui/x-charts/LineChart';
import ManIcon from '@mui/icons-material/Man';
import WomanIcon from '@mui/icons-material/Woman';
import { BarChart } from '@mui/x-charts/BarChart';

export interface IIpsDataProvinciasSexChartState {
    data: any[];
}

export default class IpsDataProvinciasSexChart extends React.Component<{}, IIpsDataProvinciasSexChartState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            data: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <Card>
                <CardContent>
                    <Box display={'flex'} justifyContent={'space-between'}>
                        <Typography variant="h5" component="div">
                            IPs por provincia
                        </Typography>
                        <Stack direction={'row'}>
                            <ManIcon style={{fontSize: '16px', color: Common.MAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalMen()
                            }
                            </Typography>
                            <WomanIcon style={{fontSize: '16px', color: Common.WOMAN_BORDER_COLOR}}/>
                            <Typography variant="body2">
                            {
                                this.GetTotalWomen()
                            }
                            </Typography>
                        </Stack>
                    </Box>
                    {
                        this.state.data.length > 0 && (
                            <React.Fragment>
                                <BarChart
                                    dataset={this.state.data}
                                    layout="horizontal"
                                    yAxis={[{ scaleType: 'band', dataKey: 'provincia' }]}
                                    series={[
                                        { dataKey: 'hombres', label: 'Hombres', stack: 'Total', color: Common.MAN_COLOR },
                                        { dataKey: 'mujeres', label: 'Mujeres', stack: 'Total', color: Common.WOMAN_COLOR}
                                    ]}
                                    height={this.state.data.length * 30}
                                    margin={{
                                        bottom: 80,
                                        left: 150
                                    }}
                                    slotProps={
                                        {
                                            legend: {
                                                hidden: true
                                            }
                                        }
                                    }
                                />
                                <Stack direction={'row'} justifyContent={'right'}>
                                    <div style={{backgroundColor: Common.MAN_COLOR, width: '20px', height: '6px', position: 'relative', top: '5px', margin: '0px 10px'}}></div>
                                    <Typography variant='caption'>
                                        HOMBRES
                                    </Typography>
                                    <div style={{backgroundColor: Common.WOMAN_COLOR, width: '20px', height: '6px', position: 'relative', top: '5px', margin: '0px 10px'}}></div>
                                    <Typography variant='caption'>
                                        MUJERES
                                    </Typography>
                                </Stack>
                            </React.Fragment>
                        )
                    }
                    {
                        this.state.data.length == 0 && (
                            <div className="textCenter" style={{margin: '20px 0px'}}>
                                <CircularProgress/>
                            </div>
                        )
                    }
                </CardContent>
            </Card>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/masters/ip/data/provincias/sexo/h`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = [];

            for(let i = 0; i < response.length; i++) {
                const dataItem: any = {};
                dataItem.provincia = response[i].provincia;
                dataItem.hombres = response[i].total;
                dataItem.mujeres = 0;

                data.push(dataItem);
            }

            this.GetTotalFieldWomenData(data);
        })
    }

    private GetTotalFieldWomenData(sourceData: any[]) {
        let url = `${Common.END_POINT}/masters/ip/data/provincias/sexo/m`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            const data: any[] = JSON.parse(JSON.stringify(sourceData));

            for(let i = 0; i < response.length; i++) {
                let dataItem: any = data.find((value: any) => {
                    return value.provincia.toLowerCase() == response[i].provincia.toLowerCase();
                });

                if (dataItem == null) {
                    dataItem = {};
                    dataItem.provincia = response[i].provincia;
                    dataItem.hombres = 0;

                    data.push(dataItem);
                }

                dataItem.mujeres = response[i].total;
            }

            data.sort((a, b) => {
                if(a.provincia < b.provincia) { return -1; }
                if(a.provincia > b.provincia) { return 1; }
                return 0;
            });
            
            this.setState({
                data: data
            })
        })
    }

    private GetTotalMen() {
        const data = this.state.data.filter((value: any) => {
            return value.hombres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.hombres;
        }, 0);

        return sum;
    }

    private GetTotalWomen() {
        const data = this.state.data.filter((value: any) => {
            return value.mujeres > -1;
        });

        const sum = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.mujeres;
        }, 0);

        return sum;
    }
}